export const selectPoll = ({poll}) => poll;
export const selectPollOptions = ({poll}) => poll?.options;
